import homeHover from './home-hover.svg';
import home from './home.svg';

export default { homeHover, home };
